import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
import * as z from 'zod/mini';
import { Id } from '@sigma/common/schema/Id.js';
export const SubscriptionGetClientSecretEndpointParams = z.object({
    subscriptionId: Id,
});
/**
 * Endpoint to retrieve the Stripe client secret for a pending subscription.
 * Used by the chat UI to render the Stripe payment form.
 */
export const SubscriptionGetClientSecretEndpoint = defineEndpoint({
    name: 'SubscriptionGetClientSecret',
    input: SubscriptionGetClientSecretEndpointParams,
    output: defineEndpoint.output(),
});
//# sourceMappingURL=SubscriptionGetClientSecretEndpoint.js.map